import shhh from 'shhh';

import { connectToStore } from './clients/lyster-client';
import connectSystemSubscriber from './modules/system/subscriber';
import networkInterceptors from './utils/network-interceptors';
import { connectToStore as connectBugsnag } from './clients/bugsnag-client';


export default function withStore(store) {
  // eslint-disable-line no-undef
  if (!__DEV__) {
    shhh.enable();
  }

  networkInterceptors(connectToStore(store), store);
  connectSystemSubscriber(store.dispatch, store.getState);
  connectBugsnag(store);
}
